export enum ReservationStatus {
    UPCOMING = 'Upcoming',
    IN_HOME = 'In Home',
    COMPLETE = 'Complete',
    CANCELED = 'Canceled',
    CLAIM_FILED = 'Claim Filed'
}